/* RÆV storefront localization for theme-editor content.
   Shopify's native locale files continue to translate standard theme UI. */
(function () {
  'use strict';

  var locale = String(document.documentElement.lang || (window.Shopify && Shopify.locale) || 'es').toLowerCase();
  var language = locale.indexOf('pt') === 0 ? 'pt' : locale.indexOf('en') === 0 ? 'en' : 'es';
  if (language === 'es') return;

  var dictionaries = {
    en: {
      'Inicio': 'Home',
      'Soporte': 'Support',
      'No te conformes. Convírtete en tu mejor versión.': 'Do not settle. Become your best version.',
      'Ver el Drop': 'View the Drop',
      'Unirse': 'Join',
      'No hay excusas ✦': 'No excuses ✦',
      'Primer Drop ✦': 'First Drop ✦',
      'Ambición. Disciplina. Carácter ✦': 'Ambition. Discipline. Character ✦',
      'Ambición. Disciplina. Carácter. ✦': 'Ambition. Discipline. Character. ✦',
      'No eres el promedio. Eres lo que construyes.': 'You are not average. You are what you build.',
      'RAEV es más que una marca. Es una comunidad de individuos que rechazan la conformidad y abrazan la disciplina.': 'RÆV is more than a brand. It is a community of people who reject conformity and embrace discipline.',
      'Sin Excusas': 'No Excuses',
      'No hay espacio para la mediocridad. Cada día es una oportunidad para superar tus límites.': 'There is no room for mediocrity. Every day is an opportunity to push beyond your limits.',
      'Ambición': 'Ambition',
      'Construye el futuro que mereces. La grandeza no llega por casualidad, sino por decisión.': 'Build the future you deserve. Greatness does not happen by chance, but by decision.',
      'Carácter': 'Character',
      'Lo que haces cuando nadie te ve define quién eres realmente.': 'What you do when no one is watching defines who you truly are.',
      'Edición Limitada ✦': 'Limited Edition ✦',
      '50 Unidades ✦': '50 Units ✦',
      'Primer Drop — Edición Limitada': 'First Drop — Limited Edition',
      'Las ideas no cambian el mundo. Los fundadores sí. Esta pieza nace para quienes están dispuestos a asumir el riesgo de construir algo propio. Cada detalle está diseñado para representar una mentalidad: crear, ejecutar y avanzar.': 'Ideas do not change the world. Founders do. This piece was created for those willing to take the risk of building something of their own. Every detail represents one mindset: create, execute and move forward.',
      'Estilo': 'Style',
      'Negro': 'Black',
      'Edición': 'Edition',
      'Avísame cuando salga': 'Notify me when it launches',
      'Ver producto': 'View product',
      'Comunidad': 'Community',
      'Entra en la lista': 'Join the list',
      'Sé el primero en conocer los drops, contenido exclusivo y actualizaciones de la comunidad.': 'Be the first to hear about drops, exclusive content and community updates.',
      'TU EMAIL': 'YOUR EMAIL',
      'Ya estás en la lista': 'You are on the list',
      'Al suscribirte aceptas recibir comunicaciones comerciales. Consulta nuestra Política de Privacidad.': 'By subscribing, you agree to receive marketing communications. Read our Privacy Policy.',
      'Política de Privacidad': 'Privacy Policy',
      'Buscar': 'Search',
      'Cerrar': 'Close'
    },
    pt: {
      'Inicio': 'Início',
      'Soporte': 'Apoio',
      'No te conformes. Convírtete en tu mejor versión.': 'Não te conformes. Torna-te na tua melhor versão.',
      'Ver el Drop': 'Ver o Drop',
      'Unirse': 'Juntar-me',
      'No hay excusas ✦': 'Sem desculpas ✦',
      'Primer Drop ✦': 'Primeiro Drop ✦',
      'Ambición. Disciplina. Carácter ✦': 'Ambição. Disciplina. Caráter ✦',
      'Ambición. Disciplina. Carácter. ✦': 'Ambição. Disciplina. Caráter. ✦',
      'No eres el promedio. Eres lo que construyes.': 'Não és a média. És aquilo que constróis.',
      'RAEV es más que una marca. Es una comunidad de individuos que rechazan la conformidad y abrazan la disciplina.': 'A RÆV é mais do que uma marca. É uma comunidade de pessoas que rejeitam o conformismo e abraçam a disciplina.',
      'Sin Excusas': 'Sem Desculpas',
      'No hay espacio para la mediocridad. Cada día es una oportunidad para superar tus límites.': 'Não há espaço para a mediocridade. Cada dia é uma oportunidade para ultrapassares os teus limites.',
      'Ambición': 'Ambição',
      'Construye el futuro que mereces. La grandeza no llega por casualidad, sino por decisión.': 'Constrói o futuro que mereces. A grandeza não surge por acaso, mas por decisão.',
      'Carácter': 'Caráter',
      'Lo que haces cuando nadie te ve define quién eres realmente.': 'Aquilo que fazes quando ninguém está a ver define quem realmente és.',
      'Edición Limitada ✦': 'Edição Limitada ✦',
      '50 Unidades ✦': '50 Unidades ✦',
      'Primer Drop — Edición Limitada': 'Primeiro Drop — Edição Limitada',
      'Las ideas no cambian el mundo. Los fundadores sí. Esta pieza nace para quienes están dispuestos a asumir el riesgo de construir algo propio. Cada detalle está diseñado para representar una mentalidad: crear, ejecutar y avanzar.': 'As ideias não mudam o mundo. Os fundadores mudam. Esta peça nasce para quem está disposto a assumir o risco de construir algo próprio. Cada detalhe representa uma mentalidade: criar, executar e avançar.',
      'Estilo': 'Estilo',
      'Negro': 'Preto',
      'Edición': 'Edição',
      'Avísame cuando salga': 'Avisa-me quando for lançado',
      'Ver producto': 'Ver produto',
      'Comunidad': 'Comunidade',
      'Entra en la lista': 'Entra na lista',
      'Sé el primero en conocer los drops, contenido exclusivo y actualizaciones de la comunidad.': 'Sê o primeiro a conhecer os drops, conteúdo exclusivo e novidades da comunidade.',
      'TU EMAIL': 'O TEU EMAIL',
      'Ya estás en la lista': 'Já estás na lista',
      'Al suscribirte aceptas recibir comunicaciones comerciales. Consulta nuestra Política de Privacidad.': 'Ao subscreveres, aceitas receber comunicações comerciais. Consulta a nossa Política de Privacidade.',
      'Política de Privacidad': 'Política de Privacidade',
      'Buscar': 'Pesquisar',
      'Cerrar': 'Fechar'
    }
  };

  var dictionary = dictionaries[language];
  var blocked = { SCRIPT: true, STYLE: true, NOSCRIPT: true, TEXTAREA: true, CODE: true, PRE: true };

  function normalized(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function translated(value) {
    var key = normalized(value);
    return Object.prototype.hasOwnProperty.call(dictionary, key) ? dictionary[key] : null;
  }

  function translateTextNode(node) {
    if (!node || !node.parentElement || blocked[node.parentElement.tagName]) return;
    var replacement = translated(node.nodeValue);
    if (!replacement) return;
    var leading = (node.nodeValue.match(/^\s*/) || [''])[0];
    var trailing = (node.nodeValue.match(/\s*$/) || [''])[0];
    node.nodeValue = leading + replacement + trailing;
  }

  function translateAttributes(element) {
    if (!element || element.nodeType !== 1) return;
    ['placeholder', 'aria-label', 'title'].forEach(function (name) {
      if (!element.hasAttribute(name)) return;
      var replacement = translated(element.getAttribute(name));
      if (replacement) element.setAttribute(name, replacement);
    });
    if ((element.tagName === 'INPUT' || element.tagName === 'BUTTON') && element.hasAttribute('value')) {
      var valueReplacement = translated(element.getAttribute('value'));
      if (valueReplacement) element.setAttribute('value', valueReplacement);
    }
  }

  function translateRoot(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      translateTextNode(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1) translateAttributes(root);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    var current;
    while ((current = walker.nextNode())) {
      if (current.nodeType === 3) translateTextNode(current);
      else translateAttributes(current);
    }
  }

  function start() {
    translateRoot(document.body);
    var queued = false;
    var observer = new MutationObserver(function (mutations) {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(translateRoot);
          if (mutation.type === 'characterData') translateTextNode(mutation.target);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('shopify:section:load', function (event) { translateRoot(event.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
